<template>
    <Sidebar v-if="$store.state.user_data" />
    <Content class="creator-list-content" v-if="$store.state.user_data.merchant_account_id" >    
        <Loading class="static static-back" v-show="is_loading_down"/>
        <div class="inner inner-box">
            <Header @update="updateDate" :steps="steps" :active="1" />
            <Loading class="static" v-if="is_loading" />
            <div class="data-wrap" v-else>
                <header class="top">
                    <div class="left">
                        <tippy :delay="[500, 20]" placement="right" content="Add new creator and storefront">
                            <el-button class="top-btn" type="primary"
                                :disabled="$store.state.merchant_disabeld"
                                @click="showAddModal()"
                                v-if="permission_creator?.addCreators?.permission">
                                <svg-icon name="plus" />
                                Add
                            </el-button>
                        </tippy>    

                        <Dropdown
                            v-if="show_data_dropdown"
                            :key="data_filter_key"
                            :items="data_filter_items"
                            :direction_type="'left'"
                            :default_value="data_filter_index"
                            @update-dropdown="handleDataFilterChange"
                        />
                        
                        <FilterDropdown :class="{'ui-drop-spec':$store.state.spec_value.del_tag_modal}" :params="params" :disabled="is_empty_data" has_tier_filter @update-filter="updateFilter" />
                        <Dropdown 
                            :items="programs" :disabled="is_empty_data || programs.length === 0" class="dropdown-programs"
                            @update-dropdown="updateProgram" :is_update_index="true"
                            :spec_drop_filed="'list_tag_open'"
                            :default_value="0"
                            :key="tag_f_key"
                            :is_select_dropdown="true"
                            :multi_pick="true"
                            :keep_open_on_select="true"
                        >
                            <template #header>
                                <div class="tag-operation-type">
                                    <label class="radio-item">
                                        <input type="radio" v-model="tag_operation_type" value="or" />
                                        <span>Or</span>
                                    </label>
                                    <label class="radio-item">
                                        <input type="radio" v-model="tag_operation_type" value="and" />
                                        <span>And</span>
                                    </label>
                                </div>
                            </template>
                            <template #footer="{ close }">
                                <div class="tag-filter-actions">
                                    <el-button size="small" type="info" :disabled="!has_draft_tag"
                                        @click="clearPrograms">Clear</el-button>
                                    <el-button size="small" type="primary" :disabled="!is_tag_draft_dirty"
                                        @click="applyPrograms(close)">See results</el-button>
                                </div>
                            </template>
                        </Dropdown>

                        <FilterStatusDrop :disabled_status="is_empty_data || selectedCount === 0 "
                            :status_items="select_edit" :tags="all_cre_tags" :disabled="$store.state.merchant_disabeld"
                            :row="data.filter(item => item.is_selected === true)"
                            :account_type_items="select_account_type"
                            :hide_account_type="is_link_only || permission_creator?.disableCreators?.permission === 0"
                            @status_pick="updateEdit"
                            @account_type_pick="updateAccountType"
                            :key="data_key"
                        />

                    </div>
                    <div class="ui-search">
                        <Search @onenter="search" :disabled="is_empty_data" :placeholder_text="is_cj ? 'Search by creator name, email, CID or social handle' : 'Search by creator name, email or social handle' " />
                    </div>
                    <div class="right">
                        <Dropdown :items="select_pagenum" :disabled="is_empty_data" @update-dropdown="updatePagenum" />
                        <Pagenavi :disabled="is_empty_data" :page_current="current_page" :page_total="total_page"
                            @goto-page="gotoPage" />
                        <tippy :delay="[0, 20]" placement="right"
                            content="Download a .csv with storefront performance summaries. If you have selected creators below, only those performance summaries will download.">
                            <span class="download-btn" @click="downloadPdf"
                                :class="{ 'disabled': !is_loading && data.length === 0 || !permission_reports.downloadCreatorPerformanceReport.permission }">
                                <svg-icon name="download2" />
                            </span>
                        </tippy>
                    </div>
                </header>
                <div>
                    <FilterResults :params="params" @update-filter="updateFilter" :key="params" />
                </div>

                <Scrollbar :class="['data-list',open_cre_tag_drop && 'data-list-handle'  ]" :show_bar="true">
                    <Table :style="top" :class="{ 'is-loading': is_loading_data || $store.state.is_loading }" >
                        <template #head>
                            <tr>
                                <th @click="selectAll(data)">
                                    <Checkbox :checked="(selectedCount === data.length)" />
                                </th>

                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'name' && sort_val === 'asc' }, { 'desc': sort_key === 'name' && sort_val === 'desc' }]"
                                        @click="sort('name')">
                                        <span>Name</span>
                                        <i><svg-icon name="sort" /></i>
                                    </div>
                                </th>

                                <th v-if="is_cj">
                                    <tippy :delay="[0, 20]" class="flex" content="CJ company ID">
                                        <span>CID</span>
                                    </tippy>
                                </th>

                                <th v-if="is_cj">
                                    <span>Email</span>
                                </th>

                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'tikTok_follower' && sort_val === 'asc' }, { 'desc': sort_key === 'tikTok_follower' && sort_val === 'desc' }]"
                                        @click="sort('tikTok_follower')">
                                        <tippy :delay="[0, 20]" class="flex" content="TikTok userhandle and followers">
                                            <span>TikTok</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>

                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'instagram_follower' && sort_val === 'asc' }, { 'desc': sort_key === 'instagram_follower' && sort_val === 'desc' }]"
                                        @click="sort('instagram_follower')">
                                        <tippy :delay="[0, 20]" class="flex" content="Instagram userhandle and followers">
                                            <span>Instagram</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>

                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'anchor_status' && sort_val === 'asc' }, { 'desc': sort_key === 'anchor_status' && sort_val === 'desc' }]"
                                        @click="sort('anchor_status')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="The current status of each creator's account with the date that status updated. Please hover over the status to learn more.">
                                            <span>Status</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th v-if="show_view_table">
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'views' && sort_val === 'asc' }, { 'desc': sort_key === 'views' && sort_val === 'desc' }]"
                                        @click="sort('views')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="Total storefront page views during the time period selected.​">
                                            <span>Views</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'click' && sort_val === 'asc' }, { 'desc': sort_key === 'click' && sort_val === 'desc' }]"
                                        @click="sort('click')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="Total product link clicks driven by the creator during the time period selected. ​">
                                            <span>Clicks</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'sales' && sort_val === 'asc' }, { 'desc': sort_key === 'sales' && sort_val === 'desc' }]"
                                        @click="sort('sales')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="Total sales driven by the creator during the time period selected.​">
                                            <span>Sales</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'sales_value' && sort_val === 'asc' }, { 'desc': sort_key === 'sales_value' && sort_val === 'desc' }]"
                                        @click="sort('sales_value')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="Total transaction value of sales driven by the creator during the time period selected.​">
                                            <span>Sales Value</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'earnings' && sort_val === 'asc' }, { 'desc': sort_key === 'earnings' && sort_val === 'desc' }]"
                                        @click="sort('earnings')">
                                        <span>Earnings</span>
                                        <i><svg-icon name="sort" /></i>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'product_count' && sort_val === 'asc' }, { 'desc': sort_key === 'product_count' && sort_val === 'desc' }]"
                                        @click="sort('product_count')">
                                        <tippy :delay="[0, 20]" class="flex"
                                            content="Total number of products in each creator's account">
                                            <span>Products</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th v-if="is_tier_enabled">
                                    <tippy :delay="[0, 20]" content="The tier each creator currently belongs to">
                                        Tier
                                    </tippy>
                                </th>
                                <th>
                                    <div class="ico sort"
                                        :class="[{ 'asc': sort_key === 'platform_type' && sort_val === 'asc' }, { 'desc': sort_key === 'platform_type' && sort_val === 'desc' }]"
                                        @click="sort('platform_type')">
                                        <tippy :delay="[0, 20]" class="flex" content="The account type of each creator.">
                                            <span>Account Type</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>
                                <th>
                                    <div class="ico question sort"
                                        :class="[{ 'asc': sort_key === 'last_update_date' && sort_val === 'asc' }, { 'desc': sort_key === 'last_update_date' && sort_val === 'desc' }]"
                                        @click="sort('last_update_date')">
                                        <tippy :delay="[0, 20]"
                                            content="This date will change when a creator adds or edits products."
                                            class="flex question">
                                            <span>Last Update</span>
                                            <i><svg-icon name="sort" /></i>
                                        </tippy>
                                    </div>
                                </th>

                                <th>
                                    
                                    <tippy :delay="[0, 20]" content="Add Tags to group and organize your creators" >
                                        Tag
                                    </tippy>
                                </th>
                                <!-- hide in 6831 -->
                                <!-- <th class="menu">
                                    <div class="ico menu"><svg-icon name="menu" /></div>
                                </th> -->
                            </tr>
                        </template>

                        <template #body :key="data_key">
                            
                            <!-- template pic -->
                            <template v-if="!is_loading && data.length === 0 && !this.isFilter">
                                <tr>
                                    <td :colspan="(is_cj ? 15 : 13) + (is_tier_enabled ? 1 : 0)">
                                        <NoData :image="require('@/assets/images/no-merchant.png')"
                                            :text="permission_creator?.addCreators?.permission ?'Add your first creator to get started':''"
                                            title="No active storefronts yet">
                                            <br><br>
                                            <router-link v-if="permission_creator?.addCreators?.permission" to="/creator/get-started"><el-button type="primary">Add Creators</el-button></router-link>
                                        </NoData>
                                    </td>
                                </tr>
                            </template>

                            <template v-if="!is_loading && data.length === 0 && this.isFilter">
                                <tr>
                                    <td :colspan="(is_cj ? 15 : 13) + (is_tier_enabled ? 1 : 0)">
                                        <NoData />
                                    </td>
                                </tr>
                            </template>

                            <tr v-else v-for="(row, index) in data" :key="row.id" :class="{ 'selected': row.is_selected ,'name-open': data.some(e=> e.row_open) ,}" @click="open(row, $event)" 
                                :id="`js-creator-${row.id}`">
                                <td @click.stop="row.is_selected = !row.is_selected; updateDropdown();">
                                    <Checkbox :checked="row.is_selected" />
                                </td>

                                <td :class="['name',$store.state.merchant_disabeld && 'name-disabeld']">
                                    <div class="flex">
                                        <figure>
                                            <img v-if="row.userProfile" :src="row.userProfile.avatar_full_url" @error="imageError($event)" />
                                        </figure>

                                        <div>
                                            <div class="flex">
                                                <strong class="flex">
                                                    <tippy v-if="row.is_motom_internal_user"
                                                        content="Motom internal staff, not visible to the public">
                                                        <svg-icon name="logo-m" />
                                                    </tippy>
                                                    <tippy :content="showFullText(row, 'name')"
                                                        @mouseover="isEllipsisActive($event, row)">
                                                        <span class="text-ellipsis name-text"
                                                            v-html="row.first_name + ' ' + row.last_name"></span>
                                                    </tippy>
                                                </strong>
                                                <span class="is-new" v-if="row.is_new">New</span>
                                            </div>

                                            <div :class="['flex svg-flex',row.open && 'flex-open']" v-if="!$store.state.merchant_disabeld">
                                                <i v-if="row.creator_portal_user_id && !row.chatroom_is_disable" class="chat-icon" :class="{'show-count': row.chatroom_unread_message_count}" @click.stop="EventBus.emit('open-chat', row)"><svg-icon name="comments" /></i>
                                                <svg-icon v-if="$store.state.user_data.is_motom_internal_user" name="email" @click.stop="mailtTo(row.email)"/>
                                                <svg-icon name="pen" @click.stop="editInfo(row)" v-if="permission_creator?.editCreatorInformation.permission"/>
                                                <svg-icon name="tag-plus" @click.stop="openCreTag(index,'name')" v-if="permission_creator?.addOrEditCreatorTags.permission"/>
                                                <svg-icon name="storefront" v-if="!is_link_only && row.platform_type === 'storefront' && row.share_link" @click.stop="goMotom(row.share_link)"/>
                                            </div>
                                        </div>
                                    </div>

                                    <DropdownHashtag class="tag_cre_drop" :tags="row.tags" :selected_tags="row.merchant_account_tags"
                                        :tag_type="'creator_tag'"
                                        @select-tag="selectTag"
                                        @closeKey="row.open=false;open_cre_tag_drop=false;"
                                        :outside_remove="true"
                                        :open_key="row.open"
                                        :row="row"
                                        :index="index"/>
                                </td>

                                <td class="cj-cid" v-if="is_cj">
                                    <span>{{ row.cj_account_info?.company_id || '---' }}</span>
                                </td>

                                <td class="cj-email" v-if="is_cj">
                                    <tippy v-if="row.email" :delay="[0, 20]" :content="row.email">
                                        <div class="text-ellipsis">{{ row.email }}</div>
                                    </tippy>
                                    <span v-else>---</span>
                                </td>

                                <td class="social">
                                    <div class="soc-fol" v-if="row.tiktok_follower_count">{{ HandleKNum(Number(row.tiktok_follower_count))  }} followers</div>
                                    <tippy class="social-row-sec storefront-soc-state" :content="showFullText(row, 'tt')"
                                        :class="['class-' + row.tiktok_connect_status , !row.tiktok_handle && 'class-none']"     
                                        @mouseover="isEllipsisActive($event, row)"
                                        @click.stop="GoMedia('tk', row.tiktok_handle)">
                                        <div v-if="row.tiktok_handle" class="text-ellipsis link text-ellipsis-link">{{row.tiktok_handle }}</div>
                                        <span v-else>---</span><br>
                                    </tippy>
                                </td>
                                <td class="social">
                                    <div class="soc-fol"  v-if="row.instagram_follower_count" >{{ HandleKNum(Number(row.instagram_follower_count))  }} followers</div>
                                    <tippy class="social-row-sec storefront-soc-state" :content="showFullText(row, 'ins')"
                                        :class="['class-' + row.instagram_connect_status , !row.instagram_handle && 'class-none']" 
                                        @mouseover="isEllipsisActive($event, row)"
                                        @click.stop="GoMedia('ig', row.instagram_handle)">
                                        <div v-if="row.instagram_handle" class="text-ellipsis link text-ellipsis-link">
                                            {{ row.instagram_handle.startsWith('@') ? '' : '@' }}{{ row.instagram_handle }}
                                        </div>
                                        <span v-else>---</span>
                                    </tippy>
                                </td>

                                <td>
                                    <tippy :delay="[0, 20]" class="storefront-state"
                                        :content="showStageText(row.anchor_page_status, $filters.momentFormat(row.show_status_time, 'll'))"
                                        :class="['class-' + row.anchor_page_status]" :key="row.anchor_page_status">
                                        {{ row.anchor_page_status_text }}
                                    </tippy>
                                    <p class="status_text_time">{{ $filters.momentFormat(row.show_status_time, 'll') }}
                                    </p>
                                    <span class="resend-link" v-if="row.anchor_page_status === -10"
                                        @click.stop="resendInvite(row)">Resend</span>
                                </td>

                                <td v-if="show_view_table">
                                    <span>{{ HandleNum(row.views) }}</span>
                                </td>
                                <td >
                                    <div class="td-flex">
                                        <span>{{ HandleNum(row.click) }}</span>
                                        <i class="lig" v-if="$store.state.save_sortlink_data === 'all' && row.click_include_shortlink_data" ><svg-icon  name="lightning" /></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="td-flex">
                                        <span>{{ HandleNum(row.sales) }}</span>
                                        <i class="lig" v-if="$store.state.save_sortlink_data === 'all' && row.sales_include_shortlink_data" ><svg-icon  name="lightning" /></i>
                                    </div>
                                </td>
                                <td>
                                    <div class="td-flex">
                                        <span v-if="row.sales_value">${{ row.sales_value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                            }}</span>
                                        <span v-else>---</span>
                                        <i class="lig" v-if="$store.state.save_sortlink_data === 'all' && row.sale_value_include_shortlink_data" ><svg-icon  name="lightning" /></i>
                                    </div>
                                </td>
                                <td>
                                    <span v-if="row.earnings">${{ row.earnings.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</span>
                                    <span v-else>---</span>
                                </td>
                                <td>
                                    <span>{{ HandleNum(Number(row.product_count)) }}</span>
                                </td>
                                <td v-if="is_tier_enabled" class="tier-cell">
                                    <div class="tier-cell-inner">
                                        <TierBadge v-if="rowTier(row)" :tier="rowTier(row)" :size="24" />
                                        <span v-else>---</span>
                                    </div>
                                </td>
                                <td class="account-type-cell">
                                    <div class="account-type-content">
                                        <div class="account-type-row" :key="row.platform_type">
                                            <svg-icon :name="row.platform_type === 'linkonly' || is_link_only ? 'lightning' : 'storefront'"></svg-icon>
                                            <span>{{ row.platform_type === 'linkonly' || is_link_only  ? 'Links' : 'Storefront' }}</span>
                                        </div>

                                    </div>
                                </td>
                                <td>
                                    <time>{{ $filters.momentFormat(row.last_store_front_update_at, 'll') }}</time>
                                </td>
                                <td class="tags-list-box-td" @mouseover="$store.state.merchant_disabeld ? none : row.hover_tag_list_box=true" @mouseleave="row.hover_tag_list_box = false">
                                    <span :class="['tags-list-box',( row.hover_tag_list_box || row.last_tag_open || row.last_tag_all_open) && 'edit-tags-list-box']" >
                                        <div @click.stop="openCreTag(index,'tag');row.last_tag_all_open=false;" class="add-tag-btn" v-show="row.edit_tag_list_box || row.hover_tag_list_box && permission_creator?.addOrEditCreatorTags.permission"><svg-icon name="tag-plus" /></div>
                                        <Badage :class="['tag-item-box', styleTagLong(row,v,k)]" v-for="(v,k) in row.merchant_account_tags.filter((ee,kk)=>{return kk < 2 })" :key="k" :value="v.text" :show_tippy="true">
                                            <svg-icon v-if="permission_creator?.addOrEditCreatorTags.permission"  :class="{'ths-show': ( row.hover_tag_list_box || row.last_tag_open || row.last_tag_all_open) }" name="close" @click.stop="handleSelectTag({tag:v, row:row },'from_outside')"/>
                                        </Badage >
                                        <Badage @click.stop="openCreTag(index,'tag_all');row.last_tag_open=false;"  v-if="row.merchant_account_tags.length - 2 > 0" :value="`+${ row.merchant_account_tags.length - 2}`"></Badage>
                                    </span>
                                    <!-- close:last_tag_open -->
                                    <DropdownHashtag class="tag_cre_drop-last" :tags="row.tags" :selected_tags="row.merchant_account_tags"
                                        :tag_type="'creator_tag'"
                                        @select-tag="selectTag"
                                        @closeKey="row.last_tag_open=false;open_cre_tag_drop=false;"
                                        :outside_remove="true"
                                        :open_key="row.last_tag_open"
                                        :row="row"
                                        :drop_css="'right:200px'"
                                        :index="index"/>
                                    <!-- open:last_tag_all_open -->
                                    <HashtagPopup 
                                        :tags="row.merchant_account_tags"
                                        :row="row" 
                                        :open_key="row.last_tag_all_open"
                                        :drop_css="'right:200px'"
                                        :index="index"
                                        @closeKey="row.last_tag_all_open=false;"
                                        @open-cre-tag="openCreTag(index,'tag');row.last_tag_all_open=false;"
                                    />
                                </td>
                            </tr>
                        </template>
                        <template #foot v-if="total && total.total_storefront_active_count && !is_loading && data.length !== 0">
                            <tr>
                                <td class="sticky-td" :colspan="2">
                                    <div>
                                        <p>Total Creators ({{ Number(total.total_creator_count).toLocaleString('en-US')  }})
                                        </p>
                                        <div class="col">
                                            <span>{{ total.total_storefront_active_count }} Active</span>
                                            <span v-if="total.total_storefront_not_available_count">
                                                {{ total.total_storefront_not_available_count }} Unavailable
                                            </span>
                                            <span>{{ total.total_storefront_disable_count }} Disabled</span>
                                            <span>{{ total.total_storefront_decline_count }} Declined</span>
                                            <span>{{ total.total_storefront_invited_count }} Added</span>
                                        </div>
                                    </div>
                                </td>
                                <td :colspan="is_cj ? 5 : 3"></td>
                                <td v-if="show_view_table">{{ total.total_views.toLocaleString('en-US') }}</td>
                                <td>{{ total.total_clicks.toLocaleString('en-US') }}</td>
                                <td>{{ total.total_sales.toLocaleString('en-US') }}</td>
                                <td>${{ Number(total.total_sales_value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}</td>
                                <td>
                                    ${{ Number(total.total_earnings).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) }}
                                </td>
                                <td>
                                    Total Products: {{ Number(total.total_creator_product_count).toLocaleString('en-US')  }}<br>
                                    Unique Products: {{ Number(total.total_product_count).toLocaleString('en-US')  }}<br>
                                </td>
                                <td v-if="is_tier_enabled"></td>
                                <td colspan="1"></td>

                                <td v-if="$store.state.user_data.is_motom_internal_user">
                                    {{ Number(total.total_creator_joined_count).toLocaleString('en-US')  }} Joined <br>
                                    {{ Number(total.total_creator_pending_count).toLocaleString('en-US')  }} Pending <br>
                                </td>

                                <td colspan="1"></td>
                            </tr>
                        </template>
                    </Table>
                </Scrollbar>
            </div>
        </div>
    </Content>

    <EditCreator ref="edit" @save="saveEdit" />

    <el-dialog v-model="is_show_add_modal" class="add-creator-modal" :show-close="false" width="650">
        <i class="close-add-creator-modal" @click="is_show_add_modal = false"><svg-icon name="close" /></i>
        <AddPartner @add-creator="addCreator" />
    </el-dialog>

    <ShareInvite ref="share">
        <svg viewBox="0 0 65 65">
            <rect x="0.5" y="0.5" width="64" height="64" rx="32" fill="#48C79C" />
            <path
                d="M29.2951 36.375L25.1251 32.205L23.7051 33.615L29.2951 39.205L41.2951 27.205L39.8851 25.795L29.2951 36.375Z"
                fill="white" />
        </svg>
        <div class="col">
            <h3>
                {{ 
                    $ProjectName === 'cj' ?
                        `Amazing! Let's help them get started.` :
                        `Amazing! Let's share your invite.`    
                }}
            </h3>
            <p v-if="$ProjectName === 'cj'">
                Share your CJ Select invite link so they can easily activate their CJ Select account.
            </p>
            <p v-else-if="$ProjectName === 'sephora'">
                Send them an invite link to join the Sephora Creator portal in order to activate 
                their storefront capability.  Storefronts become active once a creator completes 
                the registration process.
            </p>
            <p v-else>
                Send them your Anchor invite link to join Motom to activate their storefront
                capability. Storefronts become active once a creator completes the Motom
                registration process which includes prompt to accept your Anchor invite.
            </p>
        </div>
    </ShareInvite>

    <el-dialog v-model="is_show_delete_modal" class="alert-modal" :show-close="false" width="330">
        <div class="box">
            <header class="delete-header">Delete selection?</header>
            <p>{{is_sephora?'This will delete their information from your dashboard and remove their ability to create a Sephora creator account.':'This will delete their information from your dashboard and remove their invite if they have a Motom account.'}}</p>
            <div class="btns">
                <el-button @click="remove(3)">No</el-button>
                <el-button type="primary" @click="remove(2)">Yes</el-button>
            </div>
        </div>
    </el-dialog>

    <el-dialog v-model="is_show_enable_modal" class="alert-modal" :show-close="false" width="330">
        <div class="box">
            <header class="delete-header">
                <template v-if="modal_account_type === 'linkonly'">Activate links?</template>
                <template v-else-if="modal_account_type === 'mixed'">Activate storefronts? </template>
                <template v-else>Activate storefronts?</template>
            </header>
            <p v-if="modal_account_type === 'linkonly'">
                Selected creators will be able to create and share links. 
            </p>
            <p v-else-if="modal_account_type === 'mixed'">
                Selected creators will have their storefront activated and will be able to create links. All existing data will be restored in the portal.
            </p>
            <p v-else>
                This will activate {{ data.filter(row => row.is_selected === true && row.status === 100 &&
                row.anchor_page_status ===
                0).length }} creator storefronts.
            </p>
            <div class="btns">
                <el-button @click="is_show_enable_modal = false">Cancel</el-button>
                <el-button type="primary" @click="updateCreator(1)">Activate</el-button>
            </div>
        </div>
    </el-dialog>

    <el-dialog v-model="is_show_account_type_modal" class="alert-modal" :show-close="false" width="330">
        <div class="box">
            <template v-if="account_type_target === 'storefront'">
                <header class="delete-header">Enable Storefront</header>
                <p>This creator's storefront will be enabled immediately.</p>
            </template>
            <template v-else-if="account_type_target === 'linkonly'">
                <header class="delete-header">Change Account Type</header>
                <p>Storefront access will be removed. Storefront data will be retained.</p>
            </template>
            <div class="btns">
                <el-button @click="is_show_account_type_modal = false">Cancel</el-button>
                <el-button type="primary" @click="submitAccountTypeUpdate">Confirm</el-button>
            </div>
        </div>
    </el-dialog>

    <el-dialog v-model="is_show_disable_modal" class="alert-modal" :show-close="false" width="330">
        <div class="box">
            <header class="delete-header">
                <template v-if="modal_account_type === 'linkonly'">Disable links? </template>
                <template v-else-if="modal_account_type === 'mixed'">Disable storefronts? </template>
                <template v-else>Disable storefronts?</template>
            </header>
            <p v-if="modal_account_type === 'linkonly'">
                Selected creators will no longer be able to create new links. Existing link data will remain in the portal.
            </p>
            <p v-else-if="modal_account_type === 'mixed'">
                Selected creators will have their storefront deactivated and will no longer be able to create new links. All existing data will remain in the portal.
            </p>
            <p v-else>
                The storefront links will no longer be active, but all of the data will remain in the Anchor portal.
            </p>
            <div class="btns">
                <el-button @click="is_show_disable_modal = false">Cancel</el-button>
                <el-button type="primary" @click="updateCreator(2)">
                    Disable
                </el-button>
            </div>
        </div>
    </el-dialog>

    <!-- 放在這裡因為放裡面會卡到sticky -->
    <el-dialog :model-value="$store.state.spec_value.open_tag_remove_outside_modal" @close="$store.state.spec_value.open_tag_remove_outside_modal = false" class="alert-modal" :show-close="false" width="330">
        <div class="box remove-box">
            <header class="delete-header">{{ remove_text.title }}</header>
            <p>{{ remove_text.content }}</p>

            <div class="btns">
                <el-button @click.stop="$store.state.spec_value.open_tag_remove_outside_modal = false">No</el-button>
                <el-button type="primary" @click.stop="$store.state.spec_value.open_tag_remove_outside_modal = false;$store.state.spec_value.confirm_remove_outside_modal = true;">Yes, confirm</el-button>
            </div>
        </div>
    </el-dialog>
    <el-dialog :model-value="$store.state.spec_value.open_tag_edit_outside_modal" @close="$store.state.spec_value.open_tag_edit_outside_modal = false" class="alert-modal" :show-close="false" width="330">
        <div class="box remove-box">
            <header class="delete-header">Update this tag?</header>
            <p>{{`Updates will be made on ${$store.state.spec_value.del_tag_num} creators.`}}</p>

            <div class="btns">
                <el-button @click.stop="$store.state.spec_value.open_tag_edit_outside_modal = false">No</el-button>
                <el-button type="primary" @click.stop="$store.state.spec_value.open_tag_edit_outside_modal = false;$store.state.spec_value.confirm_edit_outside_modal = true;">Yes, confirm</el-button>
            </div>
        </div>
    </el-dialog>
    <el-dialog v-model="tag_remove_modal" class="alert-modal" :show-close="false" width="330">
        <div class="box remove-box" v-if="$ProjectName === 'sephora' && handle_remove_tag_value.tag.text === 'elevated'">
            <header class="delete-header">Remove the tag linked to the creator’s storefront template?</header>
            <p>You're about to remove the 'Elevated' tag, which is linked to a custom storefront template for the creator. Once removed, the creator's storefront will revert to the standard basic template, and some functionality from the current template will be limited.</p>
            <p>Are you sure you want to proceed?</p>
            <div class="btns">
                <el-button @click.stop="tag_remove_modal = false">Cancel</el-button>
                <el-button type="primary" @click.stop="tag_remove_modal = false;selectTag( handle_remove_tag_value ,'from_outside')">Confirm</el-button>
            </div>
        </div>
        <div class="box remove-box" v-else>
            <header class="delete-header">Remove tag</header>
            <p>Are you sure you want to remove the “{{ handle_remove_tag_value.tag.text }}” tag?</p>
            <div class="btns">
                <el-button @click.stop="tag_remove_modal = false">No</el-button>
                <el-button type="primary" @click.stop="tag_remove_modal = false;selectTag( handle_remove_tag_value ,'from_outside')">Yes, confirm</el-button>
            </div>
        </div>
    </el-dialog>

    <AddCreatorTagDialog/>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
// import Button from '@/components/ui/Button.vue'; // Replaced with el-button
import Content from '@/components/ui/Content.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Header from '@/components/creator/CreatorHeader.vue';
import Table from '@/components/ui/Table.vue';
import Checkbox from '@/components/ui/Checkbox.vue';
import Loading from '@/components/ui/Loading.vue';
import AddPartner from '@/components/creator/AddPartner.vue';
import EditCreator from '@/components/creator/EditCreator.vue';
import NoData from '@/components/creator/NoData.vue';
import Search from '@/components/ui/Search.vue';
import Pagenavi from '@/components/ui/Pagenavi.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import FilterDropdown from '@/components/FilterDropdown.vue';
import TierBadge from '@/components/settings/Tiers/TierBadge.vue';
import { isTierEnabled, tierFromApi } from '@/components/settings/Tiers/tierModel';
import FilterResults from '@/components/FilterResults.vue';
import ShareInvite from '@/components/ui/ShareInvite.vue';
import Badage from '@/components/ui/Badage.vue';
import DropdownHashtag from '@/components/DropdownHashtag.vue';
import FilterStatusDrop from '@/components/FilterStatusDrop';
import HashtagPopup from '@/components/HashtagPopup.vue';
import moment from 'moment';
import log from '@/utils/Log';
import { goMedia } from '@/utils/goMedia';
import { showStageText, makeStatusTime } from '@/utils/ShareEvent';
import { HandleKNum, HandleNum, handleMaxMinFun, saveSortLink, dataSourceToApi, apiToDataSource } from '@/utils/SwitchFun';
import { getTags, handleCreTag, selectTag } from '@/utils/CreatorTagFun';
import AddCreatorTagDialog from '@/components/creator/AddCreatorTagDialog.vue';
import { ElSelect, ElOption, ElButton, ElDialog } from 'element-plus';


export default {
    name: 'Creator - List',

    data() {
        return {
            is_loading: true,
            is_loading_down:false,
            is_loading_data: false,
            is_opening_modal: false,
            is_show_add_modal: false,
            is_show_more_profile_state: true,
            is_show_more_storefront_state: false,
            is_show_delete_modal: false,
            is_show_disable_modal: false,
            is_show_enable_modal: false,
            start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
            end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
            sort_key: '',
            sort_val: 'desc',
            search_keyword: '',
            data: [],
            is_show: false,
            total: {
                total_views: 0,
            },
            is_empty_data: false,
            delete_row: false,
            current_page: 1,
            total_page: 1,
            per_page: 50,
            programs: [
                { id: 99999999, text: 'All', is_selected: true },
            ],
            programs_for_cre: [],
            params: {
                profile_status: 0,
                account_type: 0,
                storefront_status: 0,
                recently_added: 0,
                metric: 0,
                metric_type: 0,
                metric_amount: '',
                metric_min_amount: '',
                metric_max_amount: '',
                social: {
                    metric: 1,
                    metric_msg: '',
                    metric_min_amount_input: '',
                    metric_max_amount_input: ''
                },
                tag:[],
                tag_operation_type: 'or',
                // { id, name } of the selected tier, null for all tiers
                tier: null,
            },
            has_filters: false,
            top: '--top: 0px',
            select_pagenum: [
                { id: 50, text: '50/page' },
                { id: 20, text: '20/page' },
            ],
            select_added: [
                { id: 1, text: 'Recently Added' },
                { id: 2, text: 'Earliest added' },
            ],
            select_edit: [
                { id: 1, text: 'Activate', disabled: true },
                { id: 2, text: 'Disable', disabled: true },
                { id: 3, text: 'Delete', disabled: true },
            ],
            select_account_type: [
                { id: 'storefront', text: 'Storefront', disabled: true },
                { id: 'linkonly', text: 'Links', disabled: true },
            ],
            is_show_account_type_modal: false,
            account_type_target: null,
            isFilter: false,
            recordOldValue: {
                width: '0',
                height: '0'
            },
            all_cre_tags:[],
            tag_operation_type: 'or',
            open_cre_tag_drop:false,
            handle_select_cre:[],//刷新table要記住上次點了誰
            tag_f_key:0,
            tag_remove_modal:false,
            handle_remove_tag_value:{//抓住準備要unbind的tag和creator
                row:null,
                tag:''
            },
            data_key:0,
            steps:[
                { title: 'Uploading', description: 'Add creators to your portal',icon:'upload' },
                { title: 'Processing', description: 'View and manage your creators',icon:'setting' },
                { title: 'Complete', description: 'Track creator storefront performance',icon:'verified'},
            ],
            data_filter_type: 'all',
            data_filter_key: 0,
            data_filter_items: [
                { text: 'All Data', value: 'all' },
                { text: 'Storefront Data', value: 'storefront' },
                { text: 'Shortlinks Data', value: 'shortlink' },
            ],
        }
    },

    computed: {
        remove_text() {
            return {
                title: `Remove tags?`,
                content: `The tag will be removed from ${this.$store.state.spec_value.del_tag_num} Creators.`
            }
        },
        selectedCount() {
            return this.data.filter(item => item.is_selected === true).length;
        },

        // The tag dropdown holds a draft: picking a tag only moves `programs`/`tag_operation_type`,
        // and See results is what commits it into `params` (the chips and the query both read params).
        draft_tag_ids() {
            return this.programs.filter(item => item.is_selected && item.id !== 99999999).map(item => item.id);
        },

        has_draft_tag() {
            return this.draft_tag_ids.length > 0;
        },

        is_tag_draft_dirty() {
            const applied_ids = this.params.tag.map(item => item.id);

            if (this.draft_tag_ids.length !== applied_ids.length) return true;
            if (this.draft_tag_ids.some(id => !applied_ids.includes(id))) return true;

            return this.tag_operation_type !== this.params.tag_operation_type;
        },

        permission_creator() {
            return this.$store.state.user_data?.permission_list?.creatorManagement;
        },
        permission_reports() {
            return this.$store.state.user_data?.permission_list?.reports;
        },

        is_sephora() {
            return this.$ProjectName === 'sephora';
        },
        is_cj() {
            return this.$ProjectName === 'cj';
        },
        is_link_only() {
            return this.$store.state.user_data?.merchant_account.platform_type === 'linkonly';
        },
        is_tier_enabled() {
            return isTierEnabled(this.$store);
        },
        modal_account_type() {
            if (this.is_link_only) return 'linkonly';
            const target_anchor_page_status = this.is_show_enable_modal ? 0 : 100;
            const rows = this.data.filter(row => row.is_selected === true && row.status === 100 && row.anchor_page_status === target_anchor_page_status);
            if (rows.length === 0) return 'storefront';
            const has_linkonly = rows.some(r => r.platform_type === 'linkonly');
            const has_storefront = rows.some(r => r.platform_type !== 'linkonly');
            if (has_linkonly && has_storefront) return 'mixed';
            return has_linkonly ? 'linkonly' : 'storefront';
        },
        has_historical_storefront_tracking() {
            if (this.$store.state.list_has_historical_storefront_tracking) {
                return this.total.total_views;
            }
            return false;
        },
        show_view_table(){
            if (this.$store.state.save_sortlink_data === 'shortlink') return false;
            const creator_any_historical = this.total.total_views;
            return (this.has_historical_storefront_tracking && this.total.total_views && this.is_link_only) || (!this.is_link_only && creator_any_historical)
        },
        show_data_dropdown(){
            return (this.has_historical_storefront_tracking && this.total.total_views && this.is_link_only) || (!this.is_link_only )
        },
        data_filter_index(){
            const idx = this.data_filter_items.findIndex(i => i.value === this.data_filter_type);
            return idx === -1 ? 0 : idx;
        }
    },

    components: {
        Sidebar,
        Content,
        Scrollbar,
        Header,
        Table,
        Checkbox,
        AddPartner,
        EditCreator,
        NoData,
        Loading,
        Search,
        Pagenavi,
        Dropdown,
        FilterDropdown,
        TierBadge,
        FilterResults,
        ShareInvite,
        Badage,
        DropdownHashtag,
        FilterStatusDrop,
        HashtagPopup,
        AddCreatorTagDialog,
        ElSelect,
        ElOption,
        ElButton,
        ElDialog,
    },

    watch: {
        '$route.params': {
            async handler() {
                this.data = [];
                this.is_loading = true;
                
                await this.getTags();
                this.startFunction()
                
            },
            immediate: true,
        },

        '$store.state.user_data.merchant_account_id': function (val) {
            this.startFunction();
        },

        //放這裡是因為可能在productModal改變狀態的時候，這邊也要改變
        '$store.state.save_sortlink_data'(val){
            this.fetchData();
        },

        // Switching Or/And never refetches on its own, the See results button applies it.
        tag_operation_type(val) {
            this.syncAllTagsState();
        }
    },

    methods: {
        GoMedia: goMedia,

        // TierBadge reads font_color / background_color / icon, the row carries the wire names,
        // so tierFromApi does the mapping in the one place that owns it
        rowTier(row) {
            return row.tier ? tierFromApi(row.tier) : null;
        },

        HandleKNum: HandleKNum,
        HandleNum: HandleNum,

        //只有在list call 這支
        sortLinkClick(){
            saveSortLink(this);
        },

        startFunction(){
            if(this.$store.state.user_data.merchant_account_id){
                let checkTime = handleMaxMinFun( this.start_date, this.end_date ,this);
                this.start_date = checkTime[0];
                this.end_date= checkTime[1];
                this.fetchData();
                if(this.$route.query.previewTag){
                    this.$store.state.creatorAddTagValue.drawer_open = true;
                }
            }
        },

        styleTagLong(row,v,k){
            if(row.merchant_account_tags.length===1){
                return `tag-item-box-only-one`
            }else if( row.merchant_account_tags.length > 1){
                if(row.merchant_account_tags[0].text.length < 8 && k === 1){
                    return `tag-item-box-pick-long`
                }else if( row.merchant_account_tags[1].text.length < 8 && k === 0){
                    return `tag-item-box-pick-long`
                }else if(row.merchant_account_tags.length ===2){
                    return 'tag-item-box-longer';                
                }else{
                    return '';
                }
            }else{
                return '';
            }
        },

        async getTags() {
            this.is_loading_data=true;
            let tagData= await getTags(this);
            if(tagData.data){
                this.all_cre_tags=[];
                tagData.data.forEach(e=>{
                    this.all_cre_tags.push(e);
                    
                })
                this.programs_for_cre=tagData.orgData;
            }
            await this.getListHadTags();
            this.is_loading_data=false;
        },

        async getListHadTags() {
            try {
                const res = await this.$ajax('/creator/get-filter-ambassador-tag-list', {
                    method: 'get',
                    data:{
                        merchant_account_id:this.$store.state.user_data.merchant_account_id
                    }
                });
                
                this.programs = [
                    { id: 99999999, text: 'All Tags', is_selected: true, disabled: false },
                ];
                res.data.data.forEach(item => {
                    this.programs.push({
                        ...item,
                        text: item['tag'],
                        is_selected: false,
                    });
                });
                // the tag list is rebuilt from scratch, so the filter goes back to its default
                this.params.tag = [];
                this.tag_operation_type = 'or';
                this.params.tag_operation_type = 'or';
                // log('blue', 'this.programs',this.programs)
            } catch (error) {
                console.error('Error fetching tag list:', error);
            }
        },

        imageError(event) {
            event.target.src = require('@/assets/images/user.png');
        },

        showAddModal(){
            this.is_show_add_modal = !this.$store.state.merchant_disabeld ?true:false;
        },

        open(row, e) {
            if (this.is_opening_modal) return;

            this.$ajax(`/get-login-user-latest-status?t=${new Date().getTime()}`, {
                method: 'get',
            }).then(res => {
                log('blue','res.data.data.status',res.data.data.status)
                if(res.data.data.status !==100 ){
                    this.$router.replace('/logout');
                }
            })

            row.user_id = row.id;
            if (e.target?.tagName !== 'A' && e.target?.parentElement?.tagName !== 'A' && e.target?.parentElement?.parentElement?.tagName !== 'A') {
                this.is_opening_modal = true;
                setTimeout(() => { this.is_opening_modal = false; }, 500);

                let d = {
                    "user_id": row.id,
                    "start_date": this.start_date,
                    "end_date": this.end_date,
                    "merchant_account_tags":row.merchant_account_tags,
                    "tags":row.tags,
                };
                window.localStorage.setItem('creator_list_get_detail_row', JSON.stringify(row));
                //時間客製文字傳進去(8968)
                this.$store.state.save_date_text = this.$store.state.save_list_date_text;
                this.EventBus.emit('open-creator-modal', d);
            }
        },


        showFullText(row, type) {
            let text = '';
            if (row.is_ellipsis_active) {
                // return row.last_name + ' ' + row.last_name;
                switch (type) {
                    case 'name':
                        text = row.first_name + ' ' + row.last_name;
                        break;
                    case 'ins':
                        text = row.instagram_handle;
                        if (row.is_instagram_handle_updated) text += ' (Updated)';
                        break;
                    case 'tt':
                        text = row.tiktok_handle;
                        if (row.is_tiktok_handle_updated) text += ' (Updated)';
                        break;
                    case 'email':
                        text = row.email;
                        break;
                }
            }

            return text;
        },

        isEllipsisActive(e, row) {
            row.is_ellipsis_active = (e.target.offsetWidth < e.target.scrollWidth);
            //target

        },

        resendInvite(row) {
            this.$ajax('/creator/update-anchor-page-status', {
                method: 'post',
                data: {
                    anchor_creator_id: row.id,
                    status: 20
                },
            }).then(res => {
                row.anchor_page_status = 20;
                row.anchor_page_status_text = 'Invited';
                row.show_status_time = new Date();
            });
        },

        showStageText: showStageText,

        gotoPage(page) {
            this.current_page = page;
            this.handle_select_cre=[];
            this.fetchData();
        },

        getApiParamStr(api,onlyfilter) {
            api = `${api}?start_date=${this.start_date}&end_date=${this.end_date}`;

            // if (this.search_keyword) api = `${api}&keyword=${this.search_keyword}`;
            if (this.search_keyword) api = `${api}&keyword=${encodeURIComponent(this.search_keyword)}`;

            // api = `${api}&per_page=${this.page_size}&page=${this.page_current}&start_date=${this.start_date}&end_date=${this.end_date}`;
            // log('blue',this.params)
            let filters = [];

            const selected_tag_ids = this.params.tag.map(e => e.id);

            if (selected_tag_ids.length > 0) {
                filters.push({ field_name: "ambassador_program_tag", logic: this.params.tag_operation_type, values: selected_tag_ids });
            }
           
            if (this.params.profile_status === 1) filters.push({ "field_name": "creator_status", "value": "joined" });
            if (this.params.profile_status === 2) filters.push({ "field_name": "creator_status", "value": "pending" });
            if (this.params.profile_status === 3) filters.push({ "field_name": "creator_status", "value": "deleted" });
            if (this.params.account_type === 0) filters.push({ "field_name": "platform_type", "value": "all" });
            if (this.params.account_type === 1) filters.push({ "field_name": "platform_type", "value": "storefront" });
            if (this.params.account_type === 2) filters.push({ "field_name": "platform_type", "value": "linkonly" });
            if (this.params.storefront_status === 1) filters.push({ "field_name": "anchor_status", "value": "active" });
            if (this.params.storefront_status === 2) filters.push({ "field_name": "anchor_status", "value": "pending" });
            if (this.params.storefront_status === 3) filters.push({ "field_name": "anchor_status", "value": "disabled" });
            if (this.params.storefront_status === 4) filters.push({ "field_name": "anchor_status", "value": "declined" });
            if (this.params.storefront_status === 5) filters.push({ "field_name": "anchor_status", "value": "invited" });
            if (this.params.recently_added === 1) filters.push({ "field_name": "recently_added", "value": "recently_added" });
            if (this.params.tier) filters.push({ "field_name": "tier_id", "value": this.params.tier.id });
            if (this.params.metric_amount !== '' || (this.params.metric_min_amount !== '' && this.params.metric_max_amount !== '')) {
                let metric_txt = '';
                switch (this.params.metric) {
                    case 0:
                        metric_txt = 'views';
                        break;
                    case 3:
                        metric_txt = 'click';
                        break;

                    case 2:
                        metric_txt = 'sales';
                        break;

                    case 1:
                        metric_txt = 'sales_value';
                        break;

                    case 4:
                        metric_txt = 'earnings';
                        break;
                }
                if (this.params.metric_type === 0)
                    filters.push({ "field_name": metric_txt, "operator": '>', "value1": this.params.metric_amount });
                else if (this.params.metric_type === 1)
                    filters.push({ "field_name": metric_txt, "operator": '<', "value1": this.params.metric_amount });
                else
                    filters.push({ "field_name": metric_txt, "value1": this.params.metric_min_amount, "value2": this.params.metric_max_amount });
            }

            //new filter
            if (this.params.social.metric_max_amount_input && this.params.social.metric_min_amount_input) {
                let whi = this.params.social.metric === 1 ? 'follower_filter_tikTok' : 'follower_filter_instagram'
                filters.push({ "field_name": whi, "value1": this.params.social.metric_min_amount_input, "value2": this.params.social.metric_max_amount_input });
            }

            if (filters.length > 0) {
                this.has_filters = true;
                api = `${api}&filters=${JSON.stringify(filters)}`;
            }
            else
                this.has_filters = false;

            //handle is it filtrer or not,except time filter.
            this.isFilter = this.search_keyword || filters.length > 0 ? true : false;

            if(!onlyfilter){
                return api;
            }else{
                return filters;
            }
        },

        downloadPdf() {
            if(!this.permission_reports.downloadCreatorPerformanceReport.permission ){
                return;
            }
            this.is_loading_down=true;
            let filter_select = this.data.filter(e => { return e.is_selected }).map(e => { return e.id });
            let filter_val= this.getApiParamStr('',true);

            let params_data = {
                start_date: this.start_date,
                end_date: this.end_date,
                page: this.current_page,
                per_page: this.per_page,
                filters:JSON.stringify(filter_val),
                is_include_shortlink_data: dataSourceToApi(this.$store.state.save_sortlink_data),
            };
            if (this.sort_key) {
                params_data.sort_key = this.sort_key;
                params_data.sort_val = this.sort_val;
            };
            if (this.search_keyword){
                params_data.keyword = this.search_keyword;
            }
            if (filter_select.length > 0) params_data.anchor_creator_ids = filter_select;

            this.$ajax('/creator/get-creator-csv-file', {
                params: params_data,
                method: 'get',
            }).then(res => {
                if (res.status == 200) {
                    let name = res.headers['content-disposition'].split('filename=');
                    name = name[1] ? name[1] : 'report';
                    this.$JsDownload(res.data, `${name}.csv`);
                    this.is_loading_down=false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download Success!`);
                } else {
                    this.is_loading_down=false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download False!`);
                }
            });
        },

        handleData(res) {
            res.data.data.data.forEach(item => {
                if (item.tiktok_handle.split('@').length > 2) {
                    item.tiktok_handle = item.tiktok_handle.replace(/@/gi, '');
                    this.$ajax('/creator/edit', {
                        method: 'post',
                        data: {
                            first_name: item.first_name,
                            last_name: item.last_name,
                            tiktok_handle: item.tiktok_handle,
                            instagram_handle: item.instagram_handle,
                            anchor_page_status: item.anchor_page_status,
                            anchor_creator_id: item.id,
                        },
                    });

                    item.tiktok_handle = '@' + item.tiktok_handle;
                }


                if (item.anchor_page_status !== 100 && item.anchor_page_status !== 0) {
                    item.views = 0;
                    item.click = 0;
                    item.sales = 0;
                    item.sales_value = 0;
                    item.product_count = 0;
                }

                item.is_can_delete = (item.status === 10 || ((item.status === 100 && item.anchor_page_status === 10) || (item.status === 100 && item.anchor_page_status === 20) || (item.status === 100 && item.anchor_page_status === -10)));
                
                if (!item.userProfile) {
                    item.userProfile = {
                        avatar_full_url: require('@/assets/images/user.png')
                    }
                }

                this.handleCreTag(item);

                
                const matchS = this.handle_select_cre.find(creItem => creItem.id === item.id);
                if (matchS) {
                    item.is_selected = true;
                }
        
            });

            return res;
        },

        async fetchData() {
            if (!this.is_loading) this.is_loading_data = true;
            let api = this.getApiParamStr('/creator/list');
            api = `${api}&page=${this.current_page}&per_page=${this.per_page}&is_include_shortlink_data=${dataSourceToApi(this.$store.state.save_sortlink_data)}`;

            if (this.sort_key) api = `${api}&sort_key=${this.sort_key}&sort_val=${this.sort_val}`;

            this.$store.state.is_loading=true;
            this.$ajax(api, {
                method: 'get',
            }).then(res => {
                res = this.handleData(res);

                // calculate total views only on the first page to avoid double counting
                if (this.current_page === 1) {
                    res.data.data.data.forEach(item => {
                        if (item.views) {
                            this.total.total_views += Number(item.views);
                        }
                    });
                }

                this.data = res.data.data.data;
                this.current_page = res.data.data.current_page;
                this.total_page = res.data.data.last_page;
                this.is_loading = false;
                this.is_loading_data = false;
                this.$store.state.is_loading=false;
                this.data = makeStatusTime(this.data);
                this.updateDropdown();

                // check and open creator by query
                this.checkAndOpenCreatorByQuery();

                let api2 = this.getApiParamStr('/creator/creator-list-statistic') + `&is_include_shortlink_data=${dataSourceToApi(this.$store.state.save_sortlink_data)}`;

                this.$ajax(api2, {
                    method: 'get',
                    withCredentials: true,
                }).then(res => {
                    this.total = res.data.data;
                    this.$store.state.list_has_historical_storefront_tracking = !!res.data.data.has_historical_storefront_tracking;
                });
            });
        },

        //處理每個人的tag選擇
        handleCreTag(item){
            handleCreTag(item, this.programs_for_cre);

        },

        selectAll(rows) {
            if (rows.filter(row => row.is_selected === true).length === rows.length) {
                rows.forEach(row => {
                    row.is_selected = false;
                });
            } else {
                rows.forEach(row => {
                    row.is_selected = true;
                });
            }

            this.updateDropdown();

            // setTimeout(() => {
            //     this.scroll();
            // }, 10);
        },

        addCreator(data) {
            this.$store.state.upload_data = data;
            this.is_show_list = true;
            this.is_show_add_modal = false;

            setTimeout(() => {
                this.$router.push('/creator/get-started');
            }, 100);
        },

        updatePagenum(obj) {
            this.per_page = obj.id;
            this.handle_select_cre=[];
            this.fetchData();
            // log('blue',obj)
        },

        updateDate(obj) {
            // log('blue',obj);
            this.start_date = moment(obj.start_date).format('YYYY-MM-DD');
            this.end_date = moment(obj.end_date).format('YYYY-MM-DD');
            this.handle_select_cre=[];
            this.fetchData();
        },

        updateFilter(obj) {
            const tagIds = Array.isArray(obj.tag) ? obj.tag.map(t => t.id) : [];

            this.programs.forEach(program => {
                if (tagIds.length === 0) {
                    program.is_selected = false;
                    // 條件 1：如果 obj.tag 是空的，啟用 id 為 99999999 的項目
                    if (program.id === 99999999) {
                        program.is_selected = true;
                    };
                    this.handle_select_cre=[]
                    this.tag_f_key+=1;
                } else {
                    // 條件 2：根據 tagIds 比對並更新 is_selected
                    program.is_selected = tagIds.includes(program.id);
                }
            });

            this.params = obj;
            // FilterDropdown's Default reset emits params without the tag keys
            if (!Array.isArray(this.params.tag)) this.params.tag = [];

            // the chips are the applied filter, so the dropdown draft goes back in step with them
            this.tag_operation_type = tagIds.length === 0 ? 'or' : this.params.tag_operation_type;
            this.params.tag_operation_type = this.tag_operation_type;
            this.syncAllTagsState();

            this.handle_select_cre=[];
            this.fetchData();
        },

        updateDropdown() {
            this.select_edit[0].disabled = this.data.filter(row => row.is_selected === true && row.status === 100 && row.anchor_page_status === 0).length === 0;
            this.select_edit[1].disabled = this.data.filter(row => row.is_selected === true && row.status === 100 && row.anchor_page_status === 100).length === 0;
            // this.select_edit[0].disabled = this.data.filter(row => row.is_selected === true && row.is_can_active).length === 0;
            // this.select_edit[1].disabled = this.data.filter(row => row.is_selected === true && row.is_can_disable).length === 0;
            this.select_edit[2].disabled = this.data.filter(row => row.is_selected === true && row.is_can_delete).length === 0;

            const selected_rows = this.data.filter(row => row.is_selected === true);
            const has_linkonly_selected = selected_rows.some(r => r.platform_type === 'linkonly');
            const has_storefront_selected = selected_rows.some(r => r.platform_type !== 'linkonly');
            this.select_account_type[0].disabled = !has_linkonly_selected;
            this.select_account_type[1].disabled = !has_storefront_selected;

            this.handle_select_cre = selected_rows;
            // log('blue',this.select_edit)
        },

        // 'All' means "no tag filter", which only makes sense as an Or, so And disables it.
        syncAllTagsState() {
            const all_program = this.programs.find(item => item.id === 99999999);
            if (!all_program) return;

            const is_and = this.tag_operation_type === 'and';
            const has_tag_selected = this.programs.some(item => item.id !== 99999999 && item.is_selected);

            all_program.disabled = is_and;
            all_program.is_selected = is_and ? false : !has_tag_selected;
        },

        // Draft only — nothing here touches `params`, so the chips and the table stay on the
        // applied filter until See results commits it.
        updateProgram(obj) {
            // log('blue',obj);
            const isAll= obj.id === 99999999;
            this.programs.forEach(item => {
                //item.is_selected = false;
                if(isAll){
                    if( item.id === 99999999) {
                        item.is_selected = true;
                    }else{
                        item.is_selected = false;
                    }
                }else{
                    if (item.id === obj.id) {
                        // clicking a picked tag again drops it, only 'All' cannot be toggled off
                        item.is_selected = !item.is_selected;
                    }else if(item.id === 99999999 && item.is_selected ){
                        item.is_selected = false;
                    }
                }
            });

            // back to no tag filter, so the Or/And choice goes back to its default
            if (isAll || !this.has_draft_tag) this.tag_operation_type = 'or';
            this.syncAllTagsState();
        },

        // 'All Tags' is the no-filter option, so clearing is the same as picking it.
        clearPrograms() {
            const all_program = this.programs.find(item => item.id === 99999999);
            if (all_program) this.updateProgram(all_program);
        },

        applyPrograms(close) {
            this.params.tag = this.programs
                .filter(item => item.is_selected && item.id !== 99999999)
                .map(item => ({ id: item.id, text: item.text }));
            this.params.tag_operation_type = this.tag_operation_type;

            this.handle_select_cre = [];

            close();
            this.fetchData();
        },

        updateEdit(obj) {
            if(obj.disabled){
                return;
            }
            switch (obj.id) {
                case 1:
                    this.is_show_enable_modal = true;
                    break;
                case 2:
                    this.is_show_disable_modal = true;
                    break;
                case 3:
                    this.remove(1);
                    break;

            }
        },

        updateAccountType(obj) {
            if (obj.disabled) return;
            this.account_type_target = obj.id;
            this.is_show_account_type_modal = true;
        },

        async submitAccountTypeUpdate() {
            const target = this.account_type_target;
            if (target !== 'storefront' && target !== 'linkonly') {
                this.is_show_account_type_modal = false;
                return;
            }

            const selected_rows = this.data.filter(row => row.is_selected === true);
            const anchor_creator_ids = selected_rows.map(row => row.id);
            this.is_show_account_type_modal = false;

            if (anchor_creator_ids.length === 0) return;

            try {
                const res = await this.$ajax('/creator/bulk-update-platform-type', {
                    method: 'post',
                    data: {
                        anchor_creator_ids,
                        platform_type: target,
                    },
                });

                const update_count = res?.data?.data?.update_count ?? 0;
                const type_label = target === 'linkonly' ? 'Links' : 'Storefront';
                this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + `${update_count} creators updated to ${type_label}.`);

                this.fetchData();
            } catch (error) {
                console.error('bulk-update-platform-type failed', error);
            }
        },

        updateCreator(type) {
            this.is_show_disable_modal = false;
            this.is_show_enable_modal = false;
            const form_data = {};
            let rows = [];
            let text = '';
            form_data.anchor_creator_ids = [];

            switch (type) {
                case 1:
                    form_data.status = 100;
                    rows = this.select_edit[0].disabled = this.data.filter(row => row.is_selected === true && row.status === 100 && row.anchor_page_status === 0);


                    rows.forEach((item) => {
                        form_data.anchor_creator_ids.push(item.id);

                        this.data.forEach((u) => {
                            if (u.id === item.id) {
                                u.anchor_page_status = 100;
                                u.anchor_page_status_text = 'Active';
                                u.show_status_time = u.accept_store_front_datetime;
                            }
                        });
                    });
                    text = `${form_data.anchor_creator_ids.length} storefronts activated.`;
                    break;
                case 2:
                    form_data.status = 0;
                    rows = this.select_edit[0].disabled = this.data.filter(row => row.is_selected === true && row.status === 100 && row.anchor_page_status === 100);


                    rows.forEach((item) => {
                        form_data.anchor_creator_ids.push(item.id);

                        this.data.forEach((u) => {
                            if (u.id === item.id) {
                                u.anchor_page_status = 0;
                                u.anchor_page_status_text = 'Disabled';
                                u.show_status_time = new Date();
                            }
                        });
                    });

                    text = `${form_data.anchor_creator_ids.length} storefronts disabled.`;

                    break;
            }


            this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + text);

            this.updateDropdown();
            this.$ajax('/creator/update-anchor-page-status', {
                method: 'post',
                data: form_data,
            });
        },

        remove(type) {
            switch (type) {
                case 1:
                    this.is_show_delete_modal = true;
                    break;

                case 2:
                    this.is_show_delete_modal = false;
                    const form_data = {};
                    form_data.status = -1;
                    form_data.anchor_creator_ids = [];

                    const delete_rows = this.data.filter(row => row.is_selected === true && row.is_can_delete);
                    if (this.delete_row) {
                        delete_rows.push(this.delete_row);
                        this.delete_row = false;
                    }
                    let text = '';

                    if (delete_rows.length == 1) {
                        text = delete_rows[0].first_name + ' ' + delete_rows[0].last_name + ' has been removed.';
                    } else {
                        text = 'Selected has been removed.';
                    }

                    delete_rows.forEach((item) => {
                        form_data.anchor_creator_ids.push(item.id);

                        this.data.forEach((u, index, object) => {
                            if (u.id === item.id) object.splice(index, 1);
                        });

                    });

                    this.updateDropdown();

                    this.$notify('<svg><use xlink:href="#yes--sprite"></use></svg> ' + text);
                    this.EventBus.emit('close-creator-modal');
                    this.$ajax('/creator/update-creator-status', {
                        method: 'post',
                        data: form_data,
                    }).then(res => {
                        this.$refs.edit.close();
                        this.$store.commit('check_limit', this);
                        this.refrashTable();
                    });

                    break;

                case 3:
                    this.is_show_delete_modal = false;
                    break;
            }
        },

        sort(key) {
            if (key === this.sort_key) {
                this.sort_val = this.sort_val === 'asc' ? 'desc' : 'asc';
            } else {
                this.sort_key = key;
                this.sort_val = 'desc';
            }
            this.handle_select_cre=[];
            this.fetchData();
        },

        search(keyword) {
            this.sort_key = '';
            this.sort_val = 'desc';
            this.search_keyword = keyword;
            this.handle_select_cre=[];
            this.fetchData();
        },

        share() {
            const obj = {};
            obj.url = 'test';
            this.EventBus.emit('open-share', obj);
        },

        goMotom(val) {
            window.open(val, '_blank');
        },

        mailtTo(email){
            window.location.href = `mailto:${email}`;
        },

        editInfo(row){
            if (this.is_opening_modal) return;
            this.is_opening_modal = true;
            setTimeout(() => { this.is_opening_modal = false; }, 500);
            this.$refs.edit.open(row);
        },

        saveEdit(row){
            let item = this.data.find(item => item.id === row.id);

            item.first_name = row.first_name;
            item.last_name = row.last_name;
            item.email = row.email;
            item.original_email = row.email;
            item.anchor_page_status = row.anchor_page_status;
            item.anchor_page_status_text = row.anchor_page_status_text;
            item.tiktok_handle = row.tiktok_handle ? row.tiktok_handle : ''
            item.instagram_handle = row.instagram_handle ? row.instagram_handle : '',
            item.is_allow_customize_collection_cover = row.is_allow_customize_collection_cover;
            item.platform_type = row.platform_type;
        },

        //打開個人的tag list選單
        openCreTag(index, name){
  
            this.data.forEach((e,k)=>{
                if(k===index && name==='name'){
                    e.open=!e.open;
                    e.last_tag_open=false;
                    e.last_tag_all_open=false;
                }else if(k===index && name==='tag'){
                    e.last_tag_open= !e.last_tag_open;
                    e.open=false;
                    e.last_tag_all_open=false;
                }else if(k===index && name==='tag_all'){
                    e.last_tag_all_open=!e.last_tag_all_open; 
                    e.open=false;
                }
                else{
                    e.open=false;
                    e.last_tag_open=false;
                    e.last_tag_all_open=false;
                }
            });

            this.open_cre_tag_drop= !this.data.every(e => !e.open && !e.last_tag_open) && this.data.length < 10;

        },

        //這邊會處理單人的tag刪減增加,API處理會在元件裡面做完(除了有spec_text的要另外CALL)
        selectTag(item,spec_text){
            selectTag( item, spec_text, this  ); 
        },

        handleSelectTag(item,spec_text){
            this.handle_remove_tag_value.row=item.row;
            this.handle_remove_tag_value.tag=item.tag;
            this.tag_remove_modal=true;
        },

        async refrashTable(){
            this.params.tag=[];
            this.tag_f_key+=1;
            await this.getTags();
            this.fetchData();

        },

        checkAndOpenCreatorByQuery() {
            const params = new URLSearchParams(window.location.search);
            const theId = params.get('id');
            if (theId && this.data && this.data.length > 0 ) {
                // get matched creator
                const targetId = theId;
                const matchedCreator = this.data.find(item => item.id == targetId);
                
                if (matchedCreator) {
                    setTimeout(() => {
                        const el = document.getElementById(`js-creator-${matchedCreator.id}`);
                        el.click();
                    }, 10);
                }else if(window.localStorage.getItem('creator_list_get_detail_row')){
                    setTimeout(() => {
                        this.open(JSON.parse(window.localStorage.getItem('creator_list_get_detail_row')) ,{});
                    }, 10);
                }
            }
        },

        handleDataFilterChange (item){
            this.data_filter_type = item.value;
            this.$store.state.save_sortlink_data = item.value;
            this.handle_select_cre=[];
            this.fetchData();
        },

    },

    beforeRouteLeave(to, from, next) {
        // 回上一页
        // let can_go= to.name==='analytics--overview'|| to.name==='programs--applications-list' || to.name==='settings' || to.name==='logout' || to.name==='creator--get-started';
        if(this.$store.state.creator_data_open){
            this.EventBus.emit('close-creator-modal')
            next(false); 
        }else{
            this.$store.state.save_date_text = '';
            this.$store.state.save_list_date_text = '';
            next(); 
        }
    },

    mounted() {
        if (this.$store.state.is_show_share) {
            this.$store.state.is_show_share = false;
            this.$refs.share.open();
        }

        this.EventBus.off('delete-creator');
        this.EventBus.on('delete-creator', (uid) => {
            this.delete_row = this.data.filter(row => row.id === uid)[0];
            this.is_show_delete_modal = true;
        });

        this.EventBus.off('sync-creator-data');
        this.EventBus.on('sync-creator-data', (udata) => {
            this.data.forEach(item => {
                //log('blue','item:', item)
                if (item.id === udata.id) {
                    item.storefront_state = udata.state;
                    item.first_name = udata.first_name;
                    item.last_name = udata.last_name;
                    item.anchor_page_status = udata.anchor_page_status;
                    item.anchor_page_status_text = udata.anchor_page_status_text;
                    item.tiktok_handle = udata.tiktok_handle ? udata.tiktok_handle : '';
                    item.instagram_handle = udata.instagram_handle ? udata.instagram_handle : '';
                    item.show_status_time = udata.show_status_time ? udata.show_status_time : item.show_status_time;
                }
            });
        });


        this.EventBus.off('update-table-creator');
        this.EventBus.on('update-table-creator', () => {
           this.refrashTable();
        });

        this.EventBus.off('open-table-creator');
        this.EventBus.on('open-table-creator', (row) => {
            log('blue','...?open-table-creator')
            row.user_id = row.id;
            let d = {
                "user_id": row.id,
                "start_date": this.start_date,
                "end_date": this.end_date,
                "merchant_account_tags":row.merchant_account_tags,
                "tags":row.tags,
            };

            //時間客製文字傳進去(8968)
            this.$store.state.save_date_text = this.$store.state.save_list_date_text;
            this.EventBus.emit('open-creator-modal', d);
        });
    },
}
</script>

<style lang="scss">
.creator-list-content {
    &>.inner {
        height: 100%;
        padding: 24px 48px;
        display: grid;
        grid-template-rows: auto 1fr;
        grid-template-columns: 100%;
        overflow: hidden;
    }

    .dropdown-programs .ui-dropdown--inner {
        .item-box {
            --dropdown-max-height: 300px;
        }

        .item-box--list {
            min-width: 200px;
        }

        .tag-operation-type {
            display: flex;
            gap: 24px;

            .radio-item {
                display: flex;
                align-items: center;
                cursor: pointer;

                input[type='radio'] {
                    margin: 0 8px 0 0;
                    width: 12px;
                    height: 12px;
                    accent-color: var(--dark-blue);
                    cursor: pointer;
                }

                span {
                    font: var(--font-fg-12);
                    color: var(--black-90);
                    user-select: none;
                }
            }
        }

        .tag-filter-actions {
            display: flex;
            align-items: center;

            .el-button {
                padding: 0 20px;

                & + .el-button {
                    flex: 1;
                }
            }
        }
    }

    .loading.static {
        margin-top: 48px;
    }

    .filter-results {
        margin-top: 0;
    }

    .data-wrap {
        margin: 16px 0;
        border-top: 1px solid var(--black-20);
        // min-height: 600px;
        height: calc(100% - 16px);
        overflow: hidden;
        display: grid;
        grid-template-rows: auto auto 1fr;
        grid-template-columns: 100%;

        .el-button{
            display: flex;
            padding: 0 12px;

            span{
                display: flex;
                align-items: center;
                gap:4px;
            }

            svg{
                height: 10px;
                width: 10px;
            }
        }

        .top {
            display: flex;
            align-items: center;
            padding: 16px 0;

            .ui-search {
                flex: 1;
                padding: 0 10px;

                .ui-search-input .input {
                    max-width: unset;
                }
            }

            .left {
                display: flex;
                align-items: center;
                position: relative;
                gap:10px;
                
                .top-btn{
                    svg{
                        margin-right: 4px;
                    }
                }

                .include-box{
                    margin-left: 10px;
                    background-color: var(--black-10);
                    border: solid 1px var(--black-10);
                    
                    .ui-checkbox svg{
                        margin-right: 6px;
                    }

                    .lig {
                        margin-left: 6px;      
                    }
                }

                .ui-drop-spec{
                    z-index: 0;
                }
            }

            .right {
                display: flex;
                align-items: center;

                .ui-dropdown {
                    margin-right: 10px;
                }

                .download-btn {
                    color: var(--black-90);
                    height: 32px;
                    width: 32px;
                    margin-left: 10px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    ;

                    svg {
                        height: 16px;
                        width: 16px;
                        display: block;
                    }

                    &.disabled {
                        cursor: not-allowed;

                        svg {
                            fill: var(--black-20);
                        }
                    }
                }
            }

        }

        .ui-table {
            white-space: nowrap;

            thead:after {
                z-index: 2;
            }

            .name .text-ellipsis {
                max-width: 140px;
            }

            .cj-email .text-ellipsis {
                max-width: 180px;
            }

            .tbody tr {
                cursor: pointer;
                position: relative;

                .account-type-cell {
                    .account-type-content {
                        display: flex;
                        flex-direction: column;
                        gap: 2px;

                        &.clickable {
                            cursor: pointer;

                            &:hover {
                                .account-type-row span {
                                    color: var(--blue);
                                    text-decoration: underline;
                                }
                            }
                        }
                    }
                    .account-type-row {
                        display: flex;
                        align-items: center;
                        gap: 4px;
                        svg {
                            width: 14px;
                            height: 14px;
                            color: var(--text-color);
                        }
                    }
                }

                .link-box {
                    margin-top: 2px;
                    display: inline-block;
                    margin-left: 4px;
                    color: var(--blue);
                    cursor: pointer;
                }

                svg {
                    height: 12px;
                    display: block;
                    width: 12px;
                }

            }

            thead:after {
                z-index: 3;
            }

            .thead tr,
            .tbody tr {
                th:first-child,
                th:nth-child(2),
                td:first-child,
                td:nth-child(2){
                    position: sticky;
                    z-index: 1;
                }

                th:first-child,
                td:first-child{
                    width: 36px;
                    left: 0;
                }

                th:nth-child(2),
                td:nth-child(2){
                    left: 36px;
                    
                    &::before {
                        position: absolute;
                        width: 10px;
                        height: 100%;
                        top: 0;
                        right:-10px;
                        content: '';
                        background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, .1));
                        z-index: 0;
                    }

                    &.name-open::before{
                        background: unset;
                    }
                }

                td:first-child,
                td:nth-child(2){
                    background-color: var(--white);
                    z-index: 2;
                }
            }


            .tfoot tr {
                td {
                    vertical-align: top;
                }
                td:first-child{
                    position: sticky;

                }

                td:first-child{
                    left: 0px;
                    
                    &::before {
                        position: absolute;
                        width: 10px;
                        height: 100%;
                        top: 0;
                        right:-10px;
                        content: '';
                        background: linear-gradient(-90deg, rgba(0, 0, 0, 0), rgba(0, 0, 0, .1));
                        z-index: 0;
                    }

                }

                td:first-child{ 
                    z-index: 2;
                }
            }

            td.name {
                transition: .3s;
                position: relative;
                max-width:200px;
                min-width:200px;

                .flex{
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;

                    figure{
                        height: 30px;
                        width: 30px;
                        min-width:30px;
                        margin-right:8px;

                        img {
                            height: 100%;
                            width: 100%;
                            display: block;
                            object-fit: cover;
                            border-radius: 50%;
                            //border: 1px solid var(--black-50);
                        }
                    }

                    .is-new {
                        margin-left: 6px;
                    }

                    svg {
                        width:14px;
                        height: 14px;
                        margin-right: 8px;
                        fill:var(--black-75);

                        &:hover{
                            fill:var(--black-90);
                        }
                    }

                    .svg-flex {
                        position: relative;
                        overflow: hidden;
                        height: 0px;
                        opacity: 0;
                        transition: all .2s ease;
                        

                        .chat-icon {
                            position: relative;
                            margin-right: 8px;

                            svg {
                                margin: 0;
                            }

                            &.show-count::before {
                                height: 5px;
                                width: 5px;
                                position: absolute;
                                border-radius: 50%;
                                top: 0;
                                right: 0;
                                background-color: var(--red);
                                content: '';
                            }
                        }
                    }

                }

                &>strong {
                    display: inline-flex;
                    align-items: center;

                    svg {
                        margin-right: 6px;
                    }
                }

                &:hover{
                    .svg-flex {
                        height: 14px;
                        opacity: 1;
                    }

                    .flex{
                        svg,
                        .add-tag-btn {
                            display: block;
                        }

                        .add-tag-btn {
                            width: initial;
                        }
                    }
                }

                .flex-open{
                    svg,.add-tag-btn{
                        display: block;
                    }

                    .add-tag-btn{
                        width:initial;
                    }
                }

                .tag_cre_drop{
                    left: 38px;
                }
            }

            td.tags-list-box-td{
                position:relative;
            }

            // auto layout ignores max-width on a cell, so the bounds go on the inner box
            .tier-cell-inner {
                display: flex;
                align-items: center;
                min-width: 80px;
                max-width: 120px;
                overflow: hidden;
            }

            .tags-list-box{
                display:flex;
                align-items: center;
                padding:4px;
                gap:6px;
                transition: .3s;
                border:solid 1px var(--white);
                max-width: 300px;
                min-width: 300px;

                .my-badges-iden{
                    display:flex;
                    align-items: center;
                    border-radius: 6px;

                    span{
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        overflow: hidden;
                        max-width: 86px;
                    }

                    &.tag-item-box-only-one span{
                        max-width: 250px;
                    }

                    &.tag-item-box-longer span{
                        max-width: 100px;
                    }

                    &.tag-item-box-pick-long span{
                        max-width: 150px;
                    }

                    &:first-child{
                        span{
                            max-width: 150px;
                        }
                    }
                }
                

                .svg-icon{
                    margin-left: 6px;
                    width: 0px;
                    transition: opacity 0.3s ease;

                    &.ths-show{
                        width: 8px;
                    }
                }

                &.edit-tags-list-box{
                    border:solid 1px var(--neutral);
                    border-radius:6px;
                    
                }
                
            }

            .add-tag-btn{
                padding: 4px;
                border:solid 1px var(--neutral);
                border-radius:6px;

                .svg-icon{
                    margin: unset;
                    width: 14px;
                }
            }

            //這邊要注意Application Tag目前為最後一個，這邊是針對Application Tag
            tr{
                td{
                    &:last-child{
                        min-width:200px;
                    }
                }
            }


            .text-ellipsis-link:hover {
                text-decoration: underline;
            }

            .soc-fol{
                margin-bottom: 3px;
            }

            .social-row-sec {
                span {
                    width: 100%;
                    margin-bottom: 0;
                    padding-left: 0;
                }
            }

            .tfoot td:nth-child(1) {
                &>div {
                    cursor: pointer;
                    max-width: 420px;

                    .tippy-box {
                        max-width: unset !important;
                        padding: 12px;
                        width: 820px;

                        .tippy-arrow {
                            transform: translate3d(24px, 0px, 0px) !important;
                        }

                        h3 {
                            font: var(--font-demi-14);
                            margin: 0 0 5px;
                        }

                        ul {
                            margin-left: 14px;
                            list-style: disc;

                            li {
                                margin-top: 5px;
                            }
                        }
                    }

                    &>p {
                        display: flex;
                        align-items: center;
                        margin: 0 0 6px;

                        svg {
                            fill: var(--black-50);
                            height: 12px;
                            display: block;
                            margin-right: 6px;
                            width: 12px;
                        }
                    }

                    .col {
                        padding-left: 18px;
                        display: flex;
                        flex-wrap: wrap;

                        span {
                            width: 50%;
                            padding-right: 8px;
                        }
                    }
                }

            }
        }



        //打開tag避免被head跟foot擋住
        .data-list-handle{
            overflow-y: visible;
            height:90vh;

            .ui-table{
                thead,tfoot{
                    position: relative;
                    z-index: 1;
                }
            }
        }

    }

}


.add-creator-modal-box {
    padding: 0;
}

.alert-modal,
.add-creator-modal {
    .el-dialog__body {
        padding: 0;
    }
}
</style>